import React from 'react';
import { RecoilRoot } from 'recoil';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';

import MetamaskEvents from 'components/MetamaskEvents';

// import all pages
import HomePage from 'pages/Home';
import BSCPage from 'pages/BSC';
import EthereumPage from 'pages/Ethereum';


function App() {
  return (
    <RecoilRoot>
      <MetamaskEvents />
      <Router>
        <Switch>
          <Route exact path="/" component={ HomePage } />
          <Route path="/binance-smart-chain" component={ BSCPage } />
          <Route path="/ethereum" component={ EthereumPage } />
        </Switch>
      </Router>
    </RecoilRoot>
  );
}

export default App;
